"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.revisitPayloadToFormDataHandler = revisitPayloadToFormDataHandler;
function revisitPayloadToFormDataHandler(data) {
    return {
        visitDate: data.form.visitDate,
        clinicianAppointment: {
            visitDate: data.form.nextVisitDate,
            visitStartTime: data.form.nextVisitStartTime,
            visitEndTime: data.form.nextVisitEndTime,
        },
        notes: data.form.notes || "",
    };
}
